import { createAction, props } from '@ngrx/store';
import { MemberAccess } from 'src/app/models/common/member-access.model';
import { SaleHorse, SaleHorseStatus } from 'src/app/models/sales/sale-horse.model';
import { Sale } from 'src/app/models/sales/sales.model';
import { MemberPermissionSale } from '../../../models/sales/membe-permission-sale.model';
import { LookupModel } from '../../../models/common/lookup.model';

export const ResetData = createAction('[Sales] Reset Data');

export const GetSales = createAction('[Sales] Get Sales');
export const GetSalesSuccess = createAction(
  '[Sales] Get Sales Success',
  props<{ sales: Sale[] }>()
);
export const GetSalesFailure = createAction(
  '[Sales] Get Sales Failure',
  props<{ err: any }>()
);

export const GetSaleById = createAction(
  '[Sales] Get Sale By Id',
  props<{ saleId: number }>()
);
export const GetSaleByIdSuccess = createAction(
  '[Sales] Get Sale By Id Success',
  props<{ sale: Sale }>()
);
export const GetSaleByIdFailure = createAction(
  '[Sales] Get Sale By Id Failure',
  props<{ err: any }>()
);

export const GetSaleHorses = createAction(
  '[Sales] Get Sale Horses',
  props<{ saleId: number }>()
);
export const GetSaleHorsesSuccess = createAction(
  '[Sales] Get Sale Horses Success',
  props<{ saleHorses: SaleHorse[] }>()
);
export const GetSaleHorsesFailure = createAction(
  '[Sales] Get Sale Horses Failure',
  props<{ err: any }>()
);

export const GetSaleHorse = createAction(
  '[Sales] Get Sale Horse',
  props<{ saleId: number; horseId: number }>()
);
export const GetSaleHorseSuccess = createAction(
  '[Sales] Get Sale Horse Success',
  props<{ saleHorse: SaleHorse }>()
);
export const GetSaleHorseFailure = createAction(
  '[Sales] Get Sale Horse Failure',
  props<{ err: any }>()
);

export const GetSaleStatuses = createAction(
  '[Sales] Get Sale Statuses',
  props<{ saleId: number}>()
);
export const GetSaleStatusesSuccess = createAction(
  '[Studies] Get Sale Statuses Success',
  props<{ saleStatuses: LookupModel[] }>()
);

export const GetSaleStatusesFailure = createAction(
  '[Studies] Get Sale Statuses Failure',
  props<{ err: any }>()
);

export const GetSaleTemplate = createAction(
  '[Sales] Get Sale Template',
  props<{ saleId: number }>()
);

export const GetSaleTemplateSuccess = createAction(
  '[Sales] Get Sale Template Success',
  props<{ saleTemplate: any }>()
);

export const GetSaleTemplateFailure = createAction(
  '[Sales] Get Sale Template Failure',
  props<{ err: any }>()
);

export const AcceptSaleTermsAndConditions = createAction(
  '[Sales] Accept Sale Terms And Conditions',
  props<{ saleId: number }>()
);

export const AcceptSaleTermsAndConditionsSuccess = createAction(
  '[Sales] Accept Sale Terms And Conditions Success',
  props<{ saleId: number; isAccepted: boolean }>()
);

export const AcceptSaleTermsAndConditionsFailure = createAction(
  '[Sales] Accept Sale Terms And Conditions Failure',
  props<{ err: any }>()
);

export const GetMemberAccessForSale = createAction(
  '[Sales] Get Member Access For Sale',
  props<{ saleId: number; horseId?: number }>()
);

export const GetMemberAccessForSaleSuccess = createAction(
  '[Sales] Get Member Access For Sale Success',
  props<{ memberAccess: MemberAccess }>()
);

export const GetMemberAccessForSaleFailure = createAction(
  '[Sales] Get Member Access For Sale Failure',
  props<{ err: any }>()
);

export const SyncTwSaleHorseData = createAction(
  '[Sales] Sync Sale Horse Data',
  props<{saleId: number}>()
);

export const SyncTwSaleHorseDataSuccess = createAction(
  '[Sales] Sync Sale Horse Data Success',
  props<{ response: any }>()
);

export const SyncTwSaleHorseDataFailure = createAction(
  '[Sales] Sync Sale Horse Data Failure',
  props<{ err: any }>()
);

export const updateSaleHorseStatus = createAction(
  '[SaleHorse] Update Status',
  props<{ saleHorse: SaleHorseStatus }>()
);

export const updateSaleHorseStatusSuccess = createAction(
  '[SaleHorse] Update Status Success',
  props<{ response: boolean }>()
);

export const updateSaleHorseStatusFailure = createAction(
  '[SaleHorse] Update Status Failure',
  props<{ error: any }>()
);

export const GetSaleMemberAccess = createAction(
  '[Sales] Get Sale Member Access',
  props<{ memberId: number }>()
);

export const GetSaleMemberAccessSuccess = createAction(
  '[Sales] Get Sale Member Access Success',
  props<{ response: MemberPermissionSale[] }>()
);

export const GetSaleMemberAccessFailure = createAction(
  '[Sales] Get Sale Member Access Failure',
  props<{ error: any }>()
);


export const UpdateSaleMemberAccess = createAction(
  '[Sales] Update Sale Member Access',
  props<{ model: MemberPermissionSale[] }>()
);

export const UpdateSaleMemberAccessSuccess = createAction(
  '[Sales] Update Sale Member Access Success',
  props<{ response: boolean }>()
);

export const ClearSaleMemberAccess = createAction(
  '[Sales] Clear Sale Member Access'
);

export const UpdateSaleMemberAccessFailure = createAction(
  '[Sales] Update Sale Member Access Failure',
  props<{ error: any }>()
);

export const clearSynced = createAction('[Sales] Clear Synced');

export const ResetErrorState = createAction('[Sales] Reset error state');
